import { ref } from 'vue';

const showReloginModal = ref(false);
const reloginUrl = ref('');

export function useRelogin() {
    function requireRelogin({ url } = {}) {
        if (url) {
            reloginUrl.value = url;
        }

        showReloginModal.value = true;
    }

    return {
        requireRelogin,
        showReloginModal,
        reloginUrl,
    };
}
